import { render, staticRenderFns } from "./Sell_total.vue?vue&type=template&id=2d9d601b&scoped=true&"
import script from "./Sell_total.vue?vue&type=script&lang=js&"
export * from "./Sell_total.vue?vue&type=script&lang=js&"
import style0 from "./Sell_total.vue?vue&type=style&index=0&id=2d9d601b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d601b",
  null
  
)

export default component.exports